export class InspectionInformationDto {
  public inspectionKey!: string;
  public alwaysDisplayAsControlledCategoriesInProtocolPdf?: string[];
}
